import React from "react";

// Função para formatar o valor para a moeda brasileira
const formatarMoeda = (valor) => {
  const numero = parseFloat(valor);
  if (isNaN(numero) || numero === 0) return '';
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
  }).format(numero);
};

// Função para determinar a vigência correta
const getVigencia = (etq) => {
  const precoPromo = parseFloat(etq.etq_precopromo);
  const precoApp = parseFloat(etq.etq_precoapp);

  if (precoPromo > 0 && (!precoApp || precoApp === 0)) {
    return `${etq.etq_iniciopromo} até ${etq.etq_fimpromo}`;
  }

  if (precoApp > 0) {
    return `${etq.etq_inicioapp} até ${etq.etq_fimapp}`;
  }

  return etq.etq_vigencia || '';
};

const EtiquetaCard = ({ etq }) => {
  const preco = formatarMoeda(etq.etq_preco);
  const promocao = formatarMoeda(etq.etq_precopromo);
  const app = formatarMoeda(etq.etq_precoapp);
  const vigencia = getVigencia(etq);

  // Determina o preço principal a exibir
  let precoPrincipal = '';
  let precoRiscado = '';

  if (app) {
    precoPrincipal = app;
    if (promocao && promocao !== "0") precoRiscado = promocao;
    else if (preco) precoRiscado = preco;
  } else if (promocao) {
    precoPrincipal = promocao;
    if (preco) precoRiscado = preco;
  } else {
    precoPrincipal = preco;
  }

  return (
    <div className="col-12 col-sm-6 col-lg-4 mb-3">
      <div className="card h-100 shadow-sm d-flex flex-column">
        <div className="card-body text-center">
          <img
            src={`https://cdn-cosmos.bluesoft.com.br/products/${etq.etq_ean}`}
            alt={etq.etq_descricao}
            className="img-fluid mb-2 d-block mx-auto"
            style={{ maxHeight: "150px", objectFit: "contain" }}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = 'https://multilit.com.br/wp-content/uploads/2020/03/Produto-sem-foto.png';
            }}
          />
          <h5 className="card-title fw-bold">{etq.etq_descricao}</h5>
          

          {(precoPrincipal || precoRiscado) && (
            <div className="d-flex justify-content-center align-items-center mb-1 gap-2">
              {precoRiscado && (
                <span className="text-decoration-line-through text-secondary">
                  {precoRiscado}
                </span>
              )}
              {precoPrincipal && <span className="fw-bold">{precoPrincipal}</span>}

            </div>
          )}

          {vigencia && (
            <small className="text-muted mt-2 d-block">
              Vigência: {vigencia}
            </small>
          )}
        </div>
      </div>
    </div>
  );
};

export default EtiquetaCard;
